import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowVariationComponent } from './arrow-variation.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ArrowVariationComponent],
  exports: [ArrowVariationComponent]
})
export class ArrowVariationModule {}

